import config from 'config/default';
import _ from 'lodash';
import i18n from '../i18n';
import Logger from '../logger';
import { API_V1 } from './APIs/APIv1';
import { AxiosResponse } from 'axios';

export const getAllBaseProfiles = async () => {
  try {
    const response = await API_V1.get('/profiles/base', {
      params: { ownOnly: false, isHashed: false, hasData: true, sort: 'createDate:desc' },
    });

    return response.data;
  } catch (e) {
    Logger.trace('Error while fetching all base profiles.');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e) };
  }
};

export const getGeneralProfileResults = async (id: string): Promise<AxiosResponse<any, any>['data']> => {
  try {
    const tempLang = config.supportedLanguages.includes(i18n.languages[0]) ? i18n.languages[0] : 'en';
    const language = tempLang!.split('-')[0];
    const res = await API_V1.get(`/profiles/base/${id}`, {
      params: { lang: language },
    });
    return {
      data: res.data,
    };
  } catch (e) {
    Logger.trace('Error while fetching customer intelligence analysis results.');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e) };
  }
};

export const getProfileResultByAssessmentName = async (assessmentName: string) => {
  try {
    const languageOptions = i18n.languages[0] || localStorage.getItem('i18nextLng');
    const language = languageOptions!.split('-')[0];
    const res = await API_V1.get(`/profiles/base/assessment/${assessmentName}`, {
      params: { lang: language },
    });
    return {
      data: res.data,
    };
  } catch (e) {
    Logger.trace('Error while fetching customer intelligence analysis results.');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e) };
  }
};

